import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "dailyQuotes",
  initialState: {
    isDailyQuotesOpen: false,
  },
  reducers: {
    toogleDailyQuotes: (state) => {
      state.isDailyQuotesOpen = !state.isDailyQuotesOpen;
    },
  },
});

export const { toogleDailyQuotes } = appSlice.actions;
export default appSlice.reducer;